export default __webpack_public_path__ + "static/media/2.01373fbd.jpg";